/* ZYMA questions — search and topic filters (sections/zyma-qa.liquid with "Show search" on).
   Hides non-matching questions, shows the no-matches line and announces the count. */
(() => {
  const init = (root) => {
    if (root.dataset.qaReady === 'true') return;
    root.dataset.qaReady = 'true';

    const input = root.querySelector('[data-qa-search]');
    const chips = [...root.querySelectorAll('[data-qa-filter]')];
    const items = [...root.querySelectorAll('[data-qa-item]')];
    const empty = root.querySelector('[data-qa-empty]');
    const status = root.querySelector('[data-qa-status]');
    let topic = '';

    const apply = () => {
      const query = (input?.value || '').trim().toLowerCase();
      let shown = 0;
      items.forEach((item) => {
        const visible = (!topic || item.dataset.category === topic) && (!query || item.textContent.toLowerCase().includes(query));
        item.hidden = !visible;
        if (visible) shown += 1;
      });
      if (empty) empty.hidden = shown > 0;
      if (status) {
        const template = shown === 1 ? status.dataset.countOne : status.dataset.countOther;
        status.textContent = (template || '[count]').replace('[count]', shown);
      }
    };

    input?.addEventListener('input', apply);
    chips.forEach((chip) =>
      chip.addEventListener('click', () => {
        topic = chip.dataset.qaFilter || '';
        chips.forEach((other) => other.setAttribute('aria-pressed', String(other === chip)));
        apply();
      })
    );
  };

  const run = (scope = document) => scope.querySelectorAll('[data-zyma-qa-filter]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => run());
  else run();
  document.addEventListener('shopify:section:load', (event) => run(event.target));
})();
